import { formatPhoneForDisplay } from '@/utils/phoneNumber';

/**
 * Muestra el celular del usuario según la convención del país del build.
 *
 * Antes repetía acá la lógica de Uruguay (`598` / `09`), así que en el panel
 * peruano los números quedaban sin formatear.
 */
export function formatUserPhone(phone: string | null | undefined): string {
  return formatPhoneForDisplay(phone);
}

export function normalizeUserPhone(
  user: { phoneNumber?: string | null; phone?: string | null }
): string {
  return (user.phoneNumber || user.phone || '').trim();
}
